import React, {useState} from 'react'
import * as s from './container.module.css';

import { Button } from '../Button';

type colors = 'primary' | 'secondary';
type titleVariants = 'contained' | 'text';
type titleAligns = 'left' | 'center' | 'right';

interface ContainerProps {
    color?: colors,
    title: string,
    titleVariant?: titleVariants,
    titleAlign?: titleAligns,
    buttonContent?: any,
    buttonFunction?: any,
    isModal?: boolean,
    handleModal?: any
}

const Container: React.FC<ContainerProps> = ({
    color,
    title,
    titleVariant,
    titleAlign,
    buttonContent,
    buttonFunction,
    isModal,
    handleModal,
    children
}) => {
    const containerClassName =
        `${s.container} ` +
        `${s[`container-${color || 'primary'}`]}`;

    const titleClassName =
        `${s.title} ` +
        `${s[`title-${titleVariant || 'text'}-${color || 'primary'}`]}`;

    const titleViewClassName =
        `${s.titleView} ` +
        `${s[`title-align-${titleAlign || 'center'}`]}`;

    return (
        <div className={containerClassName + ` ${(isModal) ? s['container-type-modal'] : ''}`}>
            {(isModal !== undefined) && <button className={s['close-button']} onClick={() => handleModal(!isModal)}>X</button>}
            <div className={titleClassName}>
                <div className={titleViewClassName}>
                    {title}
                </div>

                {
                    buttonContent &&
                    <Button
                        content={buttonContent}
                        type="button"
                        onClick={buttonFunction && buttonFunction}
                    />
                }
            </div>

            <div className={s.body}>
                {children}
            </div>
        </div>
    );
}

export { Container }